import React from "react"

//interfaces
import { IValidateModal } from "../../../interfaces/modals";

//components
import { BasicButton, CodeInput, IconLibrary, ThriveIcon, ThriveModal } from "thrive-components";
import LinkStyleButton from "../../../../../toolkit/src/components/elements/global/buttons/LinkStyleButton";

//styles
import './validation-modal.scss';



const ValidationModal = ({showModal, onHideModal, emailAddress, code, countDown, setCode, onResendCodeClick, onValidateClick, invalidCode} : IValidateModal) => {

    return (
        <ThriveModal 
            showModal={showModal} 
            canEscapeClose
            className="validation-modal"
            headerContent={
                <>
                    <div className="email-icon">
                        <ThriveIcon 
                            iconName={IconLibrary.MAIL}
                            sizeInPx="24"
                            color="var(--thrivePink"
                        />
                    </div>
                    Verify your email
                </>
            } 
            bodyContent={
                <div className="code-explainer">
                We've sent a 6 digit code to 
                <span className="email-address">{emailAddress || "email address"}</span>   
                </div>
            } 
            footerContent={<>
                <CodeInput 
                    codeLength={6} 
                    size={40}
                    onChange={setCode}
                />

                {invalidCode &&
                    <span className="error-indicator">
                        Code is invalid, try again
                    </span>
                }

                <BasicButton    
                    className="verify-button"
                    content={"Verify"}
                    ariaLabel={"Verify"}
                    isDisabled={code.length < 6}
                    onButtonClick={onValidateClick}
                />

                <div className="resend-information">
                    Didn't receive a code?
                    {
                        countDown !== 0
                        ?   (<span className="resend-countdown">
                                Resend code in {countDown}s
                            </span>)
                        :   <BasicButton 
                                className="resend-code-button"
                                content={"Resend code"} 
                                ariaLabel={"Resend code"}
                                onButtonClick={onResendCodeClick}
                            />
                    }
                </div>

                <LinkStyleButton
                    content="Go back" 
                    className="go-back-button" 
                    ariaLabel="Close modal" 
                    onButtonClick={onHideModal}
                />
            </>

            } 
            onCloseClick={onHideModal}            
        />
    );
}

export default ValidationModal